function updateCroFeatureSuffix(suffix, containerSelector) {
  // Get all containers
  const containers = 
    typeof containerSelector === "string" 
      ? document.querySelectorAll(containerSelector) 
      : (containerSelector instanceof NodeList ? containerSelector : [containerSelector]);

  containers.forEach(container => {
    // Find all elements inside container that have any of the data-cro-feature-* attributes
    const elements = container.querySelectorAll(
      "[data-cro-feature-clicked], [data-cro-feature-loaded], [data-cro-feature-viewed]"
    );

    elements.forEach(el => {
      ["clicked", "loaded", "viewed"].forEach(action => {
        const attr = `data-cro-feature-${action}`;
        const current = el.getAttribute(attr);
        if (current) {
          const base = current.slice(0, -1); // remove last character
          el.setAttribute(attr, base + suffix); // append new suffix
        }
      });
    });
  });
}



// Show one element by ID and hide another by ID
function showAndHideById(showId, hideId) {
    const showEl = document.getElementById(showId);
    const hideEl = document.getElementById(hideId);

    console.log("show:", showEl, "hide:", hideEl);

    if (hideEl) hideEl.classList.add("hidden");
    if (showEl) showEl.classList.remove("hidden");
}

function showHideByClass(showClass, hideClasses = []) {
  // Show all elements with showClass
  const showElements = document.querySelectorAll(`.${showClass}`);
  showElements.forEach(el => el.classList.remove("hidden"));

  // Hide all elements in hideClasses
  hideClasses.forEach(className => {
    const hideElements = document.querySelectorAll(`.${className}`);
    hideElements.forEach(el => el.classList.add("hidden"));
  });
}



document.addEventListener("DOMContentLoaded", function () {
    let themeTest = window.cro_default_cohort;


    console.log("testing on theme", themeTest);

    function collectionFilterTestA() {
        console.log("RUNNING TEST: A");
        showAndHideById("hide-b", "placeholder-filter-nav");
        updateCroFeatureSuffix("c", ".collection-stacked-slider")
        updateCroFeatureSuffix("c", ".collection-filter-slider")

        
        // let collectionfilterStacked = document.querySelector('.collection-stacked-slider')
        // let collectionfilterContainer = document.querySelector('#collection-filter-nav-container')

        // if(collectionfilterStacked){
        //     collectionfilterStacked.style.maxHeight = "1000px";
        //     collectionfilterStacked.classList.remove('mb-4')
        // }
        // if(collectionfilterContainer){
        //     collectionfilterContainer.classList.remove('pb-8')
        // }

    }

    function collectionFilterTestB() {
        console.log("RUNNING TEST: B");
   
        setTimeout(function() {
        showAndHideById("hide-a", "placeholder-filter-nav");
        showHideByClass('hide-b', []); 

        let sliderVisible = false;
        1000})
        updateCroFeatureSuffix("d", ".collection-stacked-slider")
        updateCroFeatureSuffix("d", ".collection-filter-slider")
    }


    if (themeTest === "a") {
        collectionFilterTestA();
        let collectionfilterSlider = document.querySelector('.collection-filter-slider');
        collectionfilterSlider.classList.add('slider-hidden')
        collectionfilterSlider.classList.remove('hidden')
        let collectionfilterStacked = document.querySelector('.collection-stacked-slider');
        let section = collectionfilterStacked.closest('.shopify-section')
        let sliderFixedHeight = parseInt(getComputedStyle(section).top) + 10;

        let sliderVisible = false

        window.addEventListener('scroll', () => {
          console.log('theme b hide on sticky')
          if (window.scrollY > sliderFixedHeight && !sliderVisible) {
            sliderVisible = true;
            collectionfilterSlider.classList.remove('slider-hidden');
            collectionfilterStacked.classList.add('slider-hidden');
          } else if (window.scrollY <= sliderFixedHeight && sliderVisible) {
            sliderVisible = false;
            
            collectionfilterSlider.classList.add('slider-hidden');
            collectionfilterStacked.classList.remove('slider-hidden');
          }
        });
    } else if (themeTest === "b") {
        collectionFilterTestB();
        

    } else {
        console.log("No matching test for theme:", themeTest);
        collectionFilterTestA();
    }
});
